import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import "./Login.css";
import credencial from "../img/img1.jpg";
import CryptoJS from "crypto-js";

const Login = ({ alumno, modificarAlumno, cambiarLogin, cambiarDatosPago }) => {
  const [error, guardarError] = useState(false);
  const [modal, verModal] = useState(false);
  const [modal2, verModal2] = useState(false);
  const [mensajeError, cambiarMensajeError] = useState("");

  useEffect(() => {
    cambiarDatosPago({
      referencia: "",
      importe: "",
      key: "",
    });
  }, []);

  const HandleSubmit = (e) => {
    e.preventDefault();

    //validar
    if (alumno.codigo.trim().length !== 14) {
      cambiarMensajeError("El codigo debe tener 14 caracteres");
      guardarError(true);
      return;
    }
    guardarError(false);

    //Enviar
    let formData = new FormData();
    formData.append("matricula", alumno.codigo.trim());
    formData.append(
      "cod",
      CryptoJS.SHA256("pcecytej-".concat(alumno.codigo.trim(), "-pcecytej"))
    );

    const fun = async () => {
      const res = await fetch(
        "https://escolar.cecytejalisco.edu.mx/SistemaEscolarJalisco/funcion/wsalumnos.php",
        { body: formData, method: "POST" }
      );
      const resp = await res.json();
      alumno.nombre = resp[0].nombre;
      if (alumno.nombre) {
        verModal2(true);
      } else {
        cambiarMensajeError("Alumno no encontrado, revisa tu codigo");
        guardarError(true);
      }
    };
    fun();
  };

  const modal2onCLick = () => {
    cambiarLogin(true);
  };

  const modal2No = () => {
    verModal2(false);
  };

  const HandleChange = (e) => {
    modificarAlumno({
      ...alumno,
      [e.target.name]: e.target.value.trim(),
    });
  };

  //   const test = ()=>{
  //     const pData = "7434316130317A753068723272746569::3076356C346F7366387675337A316171::gT=Kq81GSgxRhc%"
  //     const rsaPublicKey = "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"
  //     const expected = "X/GqsF19cIXMxzqlLCQWO/ZySIlL16JwJNiKSmS5pF8YjUbdK6a9PFpDTtafxdmKVyQG6unYSRCy0GimlyD+1jFvfgfYYF14Z1DtZU4Dq5ZOVhGXnK4DXUJhHM2T1dv3EtwFSurVMKGaBi6wGEX1W6xS90PvFPYv9x5NDnvkIGUvZmfE1HkP6pMUTZoxGFD1caLW13eSrsMkZ6JfeVo6kDUudKdiOMWrXFuHf7CT9Sw9krq2Hwm8uUodIKMbGsXB5XOBZZqDAxeOsTaO78+DxgRnHtB+c2J3e0PuyJmZR0/PNs7p63gmUh44yxlIJwFydQULCUAqGrPaONgTIgiHGA=="

  //     const pDataBytes = new TextEncoder('UTF-8').encode(pData)

  //     console.log("pDataBytes", pDataBytes)

  //     const data = atob(rsaPublicKey);
  // const array = Uint8Array.from(data, b => b.charCodeAt(0));
  //     CryptoJS.SHA256("pcecytej-".concat(alumno.codigo, "-pcecytej"))
  //   }

  return (
    <div className="Login container">
      <form onSubmit={HandleSubmit} className="Login-form">
        <label>Introduce tu código de alumno </label>
        <br />
        <input
          type="text"
          name="codigo"
          placeholder="Introduce tu código"
          onChange={HandleChange}
        />
        {error ? <p className="error">{mensajeError}</p> : null}
        <br />
        <button className="Login-button" type="submit">
          Enviar
        </button>
      </form>
      <p>
        ¿No sabes tu código? Puedes consultarlo en tu{" "}
        <a onClick={() => verModal(true)} className="Login-link">
          credencial
        </a>
      </p>
      {/* <div>
        <button onClick={()=>test()}>test</button>
      </div> */}
      <Modal
        className="Login-modal"
        isOpen={modal}
        ariaHideApp={false}
        onRequestClose={() => verModal(false)}
      >
        <img className="Login-img" src={credencial}></img>
      </Modal>
      <Modal
        className="Login-modal2"
        isOpen={modal2}
        ariaHideApp={false}
        onRequestClose={() => verModal2(false)}
      >
        <div className="">
          <h2>
            ¿Eres {alumno.nombre}? {"\n"}{" "}
          </h2>
        </div>
        <div className="Login-eleccion">
          <Link className="Login-button" onClick={modal2onCLick} to="/tipo">
            SI
          </Link>
          <button className="Login-button" onClick={modal2No}>
            NO
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Login;
